import * as React from "react";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Link,
} from "react-router-dom";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'

import Dashboard from './Pages/Dashboard'
import Testing from './Pages/Testing'
import Login from './Pages/Login'
// import Home from './Pages/Home'
// import Declaration from './Pages/Declaration'
// import ViewListing from './ViewListing'
import './index.css'
import { Provider } from "react-redux";
import { store } from "./redux/store";
import SubCategory from "./Pages/SubCategory";
import Activity from "./Pages/Activity";
import EntertainmentActivity from "./Pages/EntertainmentActivity";
import Entertainment from "./Pages/Entertainment";
import TestingActivity from "./Pages/TestingActivity";
import TestingSubcategory from "./Pages/TestingSubcategory";
import Users from "./Pages/Users";
import Calendar from "./Pages/Calendar";
import CalendarPdf from "./Pages/CalendarPdf";
import Bookings from "./Pages/Bookings";
import OrderComplete from "./Pages/OrderComplete";
import BookingHoliday from "./Pages/BookingHoliday";
import Shop from "./Pages/Shop";
import PublicShop from "./Pages/PublicShop";
// import ThankYou from "./Pages/Thankyou";
// import Bookings from "./Pages/Bookings";
// import QldEoi from "./Pages/QldEoi";

const router = createBrowserRouter([
  // {
  //   path: "/",
  //   element: <Home />,
  // },
  // {
  //   path: "/qldEoi",
  //   element: <QldEoi />,
  // },
  // {
  //   path: "/declaration",
  //   element: <Declaration />,
  // },
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/testing",
    element: <Testing />,
  },
  {
    path: "/entertainment",
    element: <Entertainment />,
  },
  {
    path: "/categories",
    element: <SubCategory />,
  },
  {
    path: "/testingCategories",
    element: <TestingSubcategory />,
  },
  {
    path: "/testingActivity",
    element: <TestingActivity />,
  },
  {
    path: "/activity",
    element: <Activity />,
  },
  {
    path: "/entertainmentActivity",
    element: <EntertainmentActivity />,
  },
  {
    path: "/users",
    element: <Users />,
  },
  {
    path: "/shop-online",
    element: <PublicShop />,
  },
  {
    path: "/shop",
    element: <Shop />,
  },
  {
    path: "/calendar",
    element: <Calendar />,
  },
  {
    path: "/calendarPdf",
    element: <CalendarPdf />,
  },
  {
    path: "/bookings",
    element: <Bookings />,
  },
  {
    path: "/bookingHoliday",
    element: <BookingHoliday />,
  },
  {
    path: "/orderComplete",
    element: <OrderComplete />,
  },
  {
    path: "/login",
    element: <Login />,
  }
])

createRoot(document.getElementById("root")).render(
  <>
    <Provider store={store()}>
      <RouterProvider router={router} />
      <ToastContainer />
    </Provider>
  </>
);
